import { render } from "./Expired-product.vue?vue&type=template&id=50fc60bc&scoped=true"
import script from "./Expired-product.vue?vue&type=script&lang=js"
export * from "./Expired-product.vue?vue&type=script&lang=js"

import "./Expired-product.vue?vue&type=style&index=0&id=50fc60bc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fc60bc"]])

export default __exports__